import mapLeaveIcon from "./leaveIconMapper";

export const TABLE_COLUMN_KEYS = {
  CODE: "code",
  NAME: "name",
  INCIDENT_TYPE: "incidence",
  ICON: "icon",
  APPROVAL: "approval",
  BALANCE_CONTROL: "balanceControl",
  DAYS_PER_REQUEST: "daysPerRequest",
  DAYS_PER_YEAR: "daysPerYear",
  ANNUAL_RESET: "annualReset",
  FUTURE_DATES: "futureDates",
  PAST_DATES: "pastDates",
} as const;

export const TABLE_COLUMN_HEADERS = {
  [TABLE_COLUMN_KEYS.CODE]: "Clave",
  [TABLE_COLUMN_KEYS.NAME]: "Nombre",
  [TABLE_COLUMN_KEYS.INCIDENT_TYPE]: "Tipo de incidencia",
  [TABLE_COLUMN_KEYS.ICON]: "Ícono",
  [TABLE_COLUMN_KEYS.APPROVAL]: "Aprobación",
  [TABLE_COLUMN_KEYS.BALANCE_CONTROL]: "Control de saldos",
  [TABLE_COLUMN_KEYS.DAYS_PER_REQUEST]: "Días por solicitud",
  [TABLE_COLUMN_KEYS.DAYS_PER_YEAR]: "Días por año",
  [TABLE_COLUMN_KEYS.ANNUAL_RESET]: "Reinicio anual",
  [TABLE_COLUMN_KEYS.FUTURE_DATES]: "Fechas futuras",
  [TABLE_COLUMN_KEYS.PAST_DATES]: "Fechas pasadas",
} as const;

export const EXPORT_COLUMN_KEYS = {
  ACTIVE: "active",
  CODE: TABLE_COLUMN_KEYS.CODE,
  NAME: TABLE_COLUMN_KEYS.NAME,
  INCIDENT_TYPE: TABLE_COLUMN_KEYS.INCIDENT_TYPE,
  APPROVAL: TABLE_COLUMN_KEYS.APPROVAL,
  BALANCE_CONTROL: TABLE_COLUMN_KEYS.BALANCE_CONTROL,
  DAYS_PER_REQUEST: TABLE_COLUMN_KEYS.DAYS_PER_REQUEST,
  DAYS_PER_YEAR: TABLE_COLUMN_KEYS.DAYS_PER_YEAR,
  ANNUAL_RESET: TABLE_COLUMN_KEYS.ANNUAL_RESET,
  FUTURE_DATES: TABLE_COLUMN_KEYS.FUTURE_DATES,
  PAST_DATES: TABLE_COLUMN_KEYS.PAST_DATES,
} as const;

export const EXPORT_COLUMN_HEADERS = {
  [EXPORT_COLUMN_KEYS.ACTIVE]: "Activo",
  [EXPORT_COLUMN_KEYS.CODE]: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.CODE],
  [EXPORT_COLUMN_KEYS.NAME]: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.NAME],
  [EXPORT_COLUMN_KEYS.INCIDENT_TYPE]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.INCIDENT_TYPE],
  [EXPORT_COLUMN_KEYS.APPROVAL]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.APPROVAL],
  [EXPORT_COLUMN_KEYS.BALANCE_CONTROL]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.BALANCE_CONTROL],
  [EXPORT_COLUMN_KEYS.DAYS_PER_REQUEST]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.DAYS_PER_REQUEST],
  [EXPORT_COLUMN_KEYS.DAYS_PER_YEAR]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.DAYS_PER_YEAR],
  [EXPORT_COLUMN_KEYS.ANNUAL_RESET]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.ANNUAL_RESET],
  [EXPORT_COLUMN_KEYS.FUTURE_DATES]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.FUTURE_DATES],
  [EXPORT_COLUMN_KEYS.PAST_DATES]:
    TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.PAST_DATES],
} as const;

export const LEAVE_TYPES_COLUMNS = [
  {
    field: TABLE_COLUMN_KEYS.CODE,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.CODE],
    sortable: true,
    align: "left",
    style: { width: "5.625rem", minWidth: "5.625rem" },
    frozen: true,
  },
  {
    field: TABLE_COLUMN_KEYS.NAME,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.NAME],
    sortable: true,
    align: "left",
    style: { width: "12.5rem", minWidth: "12.5rem", flex: 1 },
    frozen: true,
  },
  {
    field: TABLE_COLUMN_KEYS.INCIDENT_TYPE,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.INCIDENT_TYPE],
    sortable: true,
    align: "left",
    style: { minWidth: "15rem", flex: 1 },
  },
  {
    field: TABLE_COLUMN_KEYS.ICON,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.ICON],
    align: "center",
    style: { minWidth: "8rem" },
    body: (value) => mapLeaveIcon(value.icon),
  },
  {
    field: TABLE_COLUMN_KEYS.APPROVAL,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.APPROVAL],
    sortable: true,
    align: "left",
    style: { minWidth: "15rem", flex: 1 },
  },
  {
    field: TABLE_COLUMN_KEYS.BALANCE_CONTROL,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.BALANCE_CONTROL],
    sortable: true,
    align: "left",
    style: { minWidth: "15rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.DAYS_PER_REQUEST,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.DAYS_PER_REQUEST],
    sortable: true,
    align: "left",
    style: { minWidth: "12rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.DAYS_PER_YEAR,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.DAYS_PER_YEAR],
    sortable: true,
    align: "left",
    style: { minWidth: "12rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.ANNUAL_RESET,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.ANNUAL_RESET],
    sortable: true,
    align: "left",
    style: { minWidth: "10rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.FUTURE_DATES,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.FUTURE_DATES],
    sortable: true,
    align: "left",
    style: { minWidth: "10rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.PAST_DATES,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.PAST_DATES],
    sortable: true,
    align: "left",
    style: { minWidth: "10rem" },
  },
];
